import { useContext } from "react";
import { PipelineContext } from "./usePipelineContext";

export const usePipelineContext = () => useContext(PipelineContext);
